module.exports = __webpack_public_path__ + "img/equipment-01@2x.a8869341.png";